import GenericCrudTable from "@/components/tables/genericCrudTable";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { replaceDate } from "@/helper/dateHandling";
import { usePageHeading } from "@/helper/customHooks/usePageHeading";

export default function MailTemplateMainTable() {
  const { t } = useTranslation();
  usePageHeading(t("email_templates"));
  const navigate = useNavigate();

  return (
    <>
      <GenericCrudTable
        allowColumnFiltering={true}
        showColumnFilterbyDefault={true}
        allowOpenEditInNewTab
        customEditHandler={(row: any) => {
          const editUrl = `/settings/mailTemplateEditor/${row.original.id}`;

          if (row.allowOpenInNewTab) {
            window.open(editUrl, "_blank", "noopener,noreferrer");
          } else {
            navigate(editUrl);
          }
        }}
        entity={"mailTemplate"}
        disallowDelete={false}
        disableDeleteButtonForRow={(row: any) =>
          !(row.original.type === "one_time" && row.original.used_at_least_once)
        }
        columns={[
          { header: t("id"), accessorKey: "id", id: "id" },
          {
            header: t("name"),
            accessorKey: "name",
            id: "name",
            enableForCreate: true,
            required: true,
            errorMessage: t("field_required"),
          },
          {
            header: t("mail_subject"),
            accessorKey: "mail_subject",
            id: "mail_subject",
            enableForCreate: true,
          },
          {
            header: t("mail_body"),
            accessorKey: "mail_body",
            enableForCreate: true,
            id: "mail_body",
            textarea: true,
            required: true,
            errorMessage: t("field_required"),
          },
          {
            header: t("type"),
            accessorKey: "type",
            enableForCreate: true,
            id: "type",
            entity: "mailTemplate",
            additionalRoutePartsforGet: { available_types: "/" },
            required: true,
            errorMessage: t("field_required"),
          },
          {
            header: t("used_at_least_once"),
            accessorKey: "used_at_least_once",
            id: "used_at_least_once",
            customColumnFilterId: "used_at_least_once",
            setNoFilterParameter: true,
            customSortingKey: "used_at_least_once",
            filterVariant: "select",
            filterSelectOptions: [
              { value: "true", label: t("yes") },
              { value: "false", label: t("no") },
            ],
            accessorFn: (row: any) =>
              row.used_at_least_once ? t("yes") : t("no"),
          },
          {
            header: t("created_on"),
            accessorKey: "created_on",
            sortingFn: "datetime",
            filterVariant: "date",

            id: "created_on",
            Cell: ({ cell }: any) => {
              return <span>{replaceDate(cell.getValue(), true, true)}</span>;
            },
          },
          {
            header: t("created_by"),
            accessorKey: "created_by",
            customColumnFilterId: "created_by_name",

            id: "created_by",
            Cell: ({ cell }: any) => {
              return <span>{cell.getValue()?.name}</span>;
            },
          },
          {
            header: t("modified_on"),
            accessorKey: "modified_on",
            sortingFn: "modified_on",
            filterVariant: "date",

            id: "modified_on",
            Cell: ({ cell }: any) => {
              return <span>{replaceDate(cell.getValue(), true, true)}</span>;
            },
          },
          {
            header: t("modified_by"),
            accessorKey: "modified_by",
            customColumnFilterId: "modified_by_name",

            id: "modified_by",
            Cell: ({ cell }: any) => {
              return <span>{cell.getValue()?.name}</span>;
            },
          },
        ]}
      />
    </>
  );
}
